export default function PrepareReqApiV3() {
    const factory = this;

    // factory.construct = function () {};

    factory.preparePeriod = function (
        resourceId,
        userDisplayName,
        price,
        start,
        end,
        activityId,
        bookingTypeId
    ) {
        const obj = {
            resourceId: resourceId,
            bookingTypeId: bookingTypeId, // 1: Booking, 2 Forening, 3: Spærring // 11 Fixed-period
            note: userDisplayName,
            note2: "",
            note3: "",
            price: price,
            statusId: 0, // "New"
            start: start,
            end: end,
            activityId: activityId,
        };

        return obj;
    };

    // factory.construct();

    return factory;
}
